module.exports = __webpack_public_path__ + "static/img/wechat_pay.f65c368b.svg";